<app-choose-your-game (gameChosenEvent)="onGameChange($event)"
                      [message]="'Choose a game to view FAQs'"></app-choose-your-game>

@if (chosenGame) {
  @if (uiState === uiStateEnum.ShowLoading) {
    <div class="text-center mt-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (uiState === uiStateEnum.ShowData) {
    <div class="mb-4">
      <mat-accordion data-testid="faqs-table">
        @for (faq of faqs; track faq) {
          <mat-expansion-panel class="faq-expansion-panel font-medium">
            <mat-expansion-panel-header>
              <mat-panel-title class="faq-title">{{ faq.Question }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="font-medium faq-answer mt-3">
              <markdown [data]="faq.Answer"></markdown>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
}
